import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      highlightInformationCompanyAnalysis: {
        WARNING: 'Warning',
        CLOSE: 'Close',
        NOTE_1:
          'The panel containing this information has been removed from the workspace. You can ',
        HYPER_LINK: 're-add this panel',
        NOTE_2: ' in Preference Settings.',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      highlightInformationCompanyAnalysis: {
        WARNING: 'Chú ý',
        CLOSE: 'Đóng',
        NOTE_1:
          'Hộp tính năng chứa thông tin này đã bị xóa khỏi màn hình. Bạn có thể ',
        HYPER_LINK: 'thêm hộp tính năng',
        NOTE_2: ' này trong phần cài đặt.',
      },
    },
  }),
)
